import { ICellRendererParams } from "ag-grid-community";

import Summary from "./TradeFlowTrackerTabs/Summary";
import EditFlow from "./TradeFlowTrackerTabs/EditFlow";
import Contacts from "./TradeFlowTrackerTabs/Contacts";
import DocumentVault from "./TradeFlowTrackerTabs/DocumentVault";
import Tasks from "./TradeFlowTrackerTabs/Tasks";

import TradeFlowTracker from "./TradeFlowTrackerTabs/TradeFlowTracker";

import { DealsGridContext } from "../../types/DealTracker";
import AIAutomate from "./TradeFlowTrackerTabs/AIAutomate";

export default function CompanyNameCellRenderer(
  params: ICellRendererParams<any, any, DealsGridContext>
) {
  return (
    <TradeFlowTracker rowData={params.data} tableContext={params.context}>
      <TradeFlowTracker.Trigger value={params.value} />

      <TradeFlowTracker.Drawer>
        <TradeFlowTracker.Data>
          <TradeFlowTracker.Header>
            <TradeFlowTracker.Status />
            <TradeFlowTracker.Title />
            <TradeFlowTracker.CloseBtn />
          </TradeFlowTracker.Header>

          <TradeFlowTracker.TabsHeader />

          <TradeFlowTracker.Tabs>
            <TradeFlowTracker.Tab>
              <Summary />
            </TradeFlowTracker.Tab>

            <TradeFlowTracker.Tab>
              <EditFlow />
            </TradeFlowTracker.Tab>

            <TradeFlowTracker.Tab>
              <Contacts />
            </TradeFlowTracker.Tab>

            <TradeFlowTracker.Tab>
              <Tasks />
            </TradeFlowTracker.Tab>

            <TradeFlowTracker.Tab>
              <DocumentVault />
            </TradeFlowTracker.Tab>

            <TradeFlowTracker.Tab>
              <AIAutomate />
            </TradeFlowTracker.Tab>
          </TradeFlowTracker.Tabs>
        </TradeFlowTracker.Data>
      </TradeFlowTracker.Drawer>
    </TradeFlowTracker>
  );
}
